module.exports = __webpack_public_path__ + "img/universkin-serum-p-active-icon.3a7e7e7e.svg";